export { default as CurrenciesPrMonthReport } from './currenciesPrMonthReport.component';
